// 信审业务意向标签
export default {
  zh: {
    A: 'success',
    B: 'failed',
    C: 'unfinished',
    D: 'others',
    E: 'no-answer',
    F: 'not connected',
    G: 'voicemail'

  },
  en: {
    A: 'success',
    B: 'failed',
    C: 'unfinished',
    D: 'others',
    E: 'no-answer',
    F: 'not connected',
    G: 'voicemail'
  },
  ba: {
    A: 'success',
    B: 'failed',
    C: 'unfinished',
    D: 'others',
    E: 'no-answer',
    F: 'not connected',
    G: 'voicemail'
  }
}



// WEBPACK FOOTER //
// ./src/utils/intentionTags/infoCheckTags.js